import { render, staticRenderFns } from "./offerhelp.vue?vue&type=template&id=06db160e&"
import script from "./offerhelp.vue?vue&type=script&lang=js&"
export * from "./offerhelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06db160e')) {
      api.createRecord('06db160e', component.options)
    } else {
      api.reload('06db160e', component.options)
    }
    module.hot.accept("./offerhelp.vue?vue&type=template&id=06db160e&", function () {
      api.rerender('06db160e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Xim28Fmy9ep3/JS/comp/offerhelp.vue"
export default component.exports